<template>
  <div>
    <div class="row justify-content-md-center" v-cloak v-if="!state.loaded">
      <div class="col col-lg-2"></div>
      <div class="col-md-auto mt-20">
        <rotate-square5></rotate-square5>
      </div>
      <div class="col col-lg-2"></div>
    </div>
    <div class="card card-body printableArea" v-else>
      <h3>
        <b>Detail</b>
        <span class="pull-right">
          <button
            type="button"
            @click="goBack()"
            class="btn btn-inverse"
            title="Kembali"
          >
            Kembali
          </button>
        </span>
      </h3>
      <hr />
      <div class="row">
        <div class="col-md-12">
          <center class="m-t-30">
            <img
              :src="state.detail.avatar"
              style="width: 150px; height: 150px"
              class="img-circle"
            />
            <h4 class="card-title m-t-10">{{ state.detail.name }}</h4>
            <!-- <h6 class="card-subtitle">{{ state.detail.email }}</h6> -->
          </center>
        </div>
        <div class="col-md-12 justify-content-md-center">
          <div class="col-md-6 pull-left">
            <small class="text-muted">NIK</small>
            <h6>{{ state.detail.nik }}</h6>
            <small class="text-muted">Nama Pengguna</small>
            <h6>
              {{ state.detail.front_title }} {{ state.detail.name }}
              {{ state.detail.rear_title }}
            </h6>
            <small class="text-muted">Username</small>
            <h6>{{ state.detail.username }}</h6>
            <small class="text-muted">Email</small>
            <h6>{{ state.detail.email }}</h6>
            <small class="text-muted">No Telp</small>
            <h6>{{ state.detail.phone }}</h6>
            <small class="text-muted">Unit</small>
            <h6>
              <template
                v-if="
                  state.detail.unit != undefined &&
                  state.detail.unit.text != '-'
                "
              >
                {{ state.detail.unit.text }}
              </template>
              <template v-else>-</template>
            </h6>
            <!-- <small class="text-muted">Jabatan</small>
            <template v-if="state.detail.multipleUnits != undefined"> -->
            <!-- <h6 v-for="(item, key) in state.detail.multipleUnits"> -->
            <!-- <h6
                v-for="(item, key) in state.detail.multipleUnits"
                v-bind:key="key"
              >
                {{ item.structural.name }}
              </h6>
            </template>
            <template v-else>
              <h6>-</h6>
            </template> -->
            <small class="text-muted">Jenis Kelamin</small>
            <h6>
              <template v-if="state.detail.gender == 1"> Laki-laki </template>
              <template v-else-if="state.detail.gender == 0">
                Perempuan
              </template>
            </h6>
            <small class="text-muted">Tempat, Tanggal Lahir</small>
            <h6>
              {{ state.detail.place_birth }}, {{ state.detail.date_birth }}
            </h6>
            <small class="text-muted">Alamat</small>
            <h6>{{ state.detail.address }}</h6>
            <small class="text-muted">Provinsi</small>
            <h6>{{ province.text }}</h6>
            <small class="text-muted">Kabupaten/Kota</small>
            <h6>{{ district.text }}</h6>
            <small class="text-muted">Kecamatan</small>
            <h6>{{ subdistrict.text }}</h6>
            <small class="text-muted">Kode Pos</small>
            <h6>
              {{ state.detail.zip_code != null ? state.detail.zip_code : "-" }}
            </h6>
            <!-- <small class="text-muted">Kode Maker</small>
            <h6>{{ state.detail }}</h6> -->

            <small class="text-muted">Email address</small>
            <h6>{{ state.detail.name }}</h6>
            <small class="text-muted">Email address</small>
            <h6>{{ state.detail.email }}</h6>
            <small class="text-muted p-t-30 db">Phone</small>
            <h6>{{ state.detail.phone }}</h6>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { RotateSquare5 } from "vue-loading-spinner";
import ImageItem from "@/components/img/imgItem";
import axios from "axios";
export default {
  components: {
    RotateSquare5,
    ImageItem,
  },
  data() {
    return {
      province: {
        value: "-",
        text: "-",
      },
      district: {
        value: "-",
        text: "-",
      },
      subdistrict: {
        value: "-",
        text: "-",
      },
    };
  },
  computed: {
    base() {
      return this.baseUrl;
    },
    state() {
      return this.$store.state.user;
    },
  },
  mounted() {
    this.detailLoad();
  },
  methods: {
    detailLoad() {
      const state = {
        loaded: false,
      };
      this.$store.commit("user/STATE", state);
      this.$store.dispatch("user/getUserById", this.$route.params);
      this.provinceFind();
    },
    goBack() {
      this.$store.dispatch("user/onCancel");
    },
    provinceFind() {
      axios
        .get("province")
        .then((response) => {
          const { status, data } = response.data;
          if (data) {
            const province = Object.keys(data).map(function (key) {
              return { value: key, text: data[key] };
            });
            this.province = province.filter(
              (item) => item.value == this.state.detail.province
            )[0];
            this.districtFind(this.state.detail.province);
          }
        })
        .catch((err) => {
          // console.log(err)
        });
    },
    districtFind(id_province) {
      axios
        .get(`province/${id_province}/district`)
        .then((response) => {
          const { status, data } = response.data;
          if (data) {
            const district = Object.keys(data).map(function (key) {
              return { value: key, text: data[key] };
            });
            this.district = district.filter(
              (item) => item.value == this.state.detail.district
            )[0];
            this.subdistrictFind(id_province, this.state.detail.district);
          }
        })
        .catch((err) => {
          // console.log(err)
        });
    },
    subdistrictFind(id_province, id_district) {
      axios
        .get(`province/${id_province}/district/${id_district}/subdistrict`)
        .then((response) => {
          const { status, data } = response.data;
          if (data) {
            const subdistrict = Object.keys(data).map(function (key) {
              return { value: key, text: data[key] };
            });
            this.subdistrict = subdistrict.filter(
              (item) => item.value == this.state.detail.district
            )[0];
          }
        })
        .catch((err) => {
          // console.log(err)
        });
    },
  },
};
</script>
